import React from "react";
import Layout from "../layouts/index";
import HowItWorks from "../screens/Info/HowItWorks";

const HowItWorksPage = () => {
  return (
    <Layout>
      <HowItWorks />
    </Layout>
  );
};

export default HowItWorksPage;
